import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import AdminSidebar from './AdminSidebar';
import ShimmerLoader from "../../components/utilComponents/shimmer";

const SetCurrencyRate = () => {
  const [currentRate, setCurrentRate] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCurrencyRate = async () => {
    try {
      setLoading(true);
      const response = await fetch("https://v6.exchangerate-api.com/v6/c0003abdb606fa6078989df4/latest/USD");
      const data = await response.json();
      if (data && data.conversion_rates && data.conversion_rates.INR) {
        setCurrentRate(data.conversion_rates.INR);
      }
    } catch (error) {
      console.error("Error fetching currency rate:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    document.title = "Set Currency Rate | Bitstek Advisory";
    fetchCurrencyRate();

    const interval = setInterval(() => {
      fetchCurrencyRate();
    }, 500000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>  <AdminSidebar />
    <Container className="card mt-4">
      <h4 className="text-center text-primary" style={{fontWeight:'bold'}}>Set Currency Rate</h4>  <hr/>
     
      <Row className="mb-3 justify-content-center">
      <Col md={6}>

      <Form>
        
            <Form.Group>
              <Form.Label style={{fontWeight:'bold'}}>Current 1 USD to INR Rate</Form.Label>
              {loading ? (
                <ShimmerLoader width="100%" height="30px" />
              ) : (
                <Form.Control
                  type="number"
                  value={currentRate !== null ? currentRate : ""}
                  readOnly
                />
              )}
            </Form.Group>
        
            <br/>

            <Form.Group>
              <Form.Label style={{fontWeight:'bold'}}>Set 1 USD to INR Rate</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter USD Amount"
                required
              />
            </Form.Group>
         
        <br/>

        <div className="d-flex justify-content-center">
          <button type="submit" className="search-btn" >
                    Set
          </button>
        </div>

      </Form>
      </Col>
      </Row>
     
    </Container>
    </>
  )
}

export default SetCurrencyRate